// Migrated from react-material-workspace-layout
// Modernized for React 19 compatibility

import React from "react"
import { styled } from "@mui/material/styles"

const Container = styled("div")(({ theme }) => ({
  position: "relative",
  flexGrow: 1,
  flexShrink: 1,
  height: "100%",
  backgroundColor:
    theme.palette.mode === "dark"
      ? theme.palette.grey[900]
      : theme.palette.grey[50],
  overflowY: "auto",
}))

const ShadowOverlay = styled("div")(({ theme }) => ({
  content: "' '",
  position: "absolute",
  left: 0,
  right: 0,
  top: 0,
  bottom: 0,
  pointerEvents: "none",
  boxShadow:
    theme.palette.mode === "dark"
      ? "inset 0 3px 5px rgba(0,0,0,0.4), inset -3px 0 5px rgba(0,0,0,0.4), inset 3px 0 5px rgba(0,0,0,0.4)"
      : "inset 0 3px 5px rgba(0,0,0,0.15), inset -3px 0 5px rgba(0,0,0,0.15), inset 3px 0 5px rgba(0,0,0,0.15)",
}))

export const WorkContainer = React.forwardRef(({ children }, ref) => {
  return (
    <Container ref={ref}>
      {children}
      <ShadowOverlay />
    </Container>
  )
})

WorkContainer.displayName = "WorkContainer"

export default WorkContainer
